import { defineStore } from 'pinia'

export const useGenresStore = defineStore('genres', {
    state: () => ({
        genres: [],
    }),
    getters: {
        activeGenres: state =>
            state.genres
                .filter(genre => genre.status === 'open')
                .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0)),
    },
    actions: {
        setGenres(genres) {
            this.genres = genres
        },
    },
})
